import { render, staticRenderFns } from "./contentCardBaseB.vue?vue&type=template&id=5d7a0aab&scoped=true"
import script from "./contentCardBaseB.vue?vue&type=script&lang=js"
export * from "./contentCardBaseB.vue?vue&type=script&lang=js"
import style0 from "./contentCardBaseB.vue?vue&type=style&index=0&id=5d7a0aab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a0aab",
  null
  
)

export default component.exports